import React from 'react';
import { ProductImageGallery } from './ProductImageGallery';
import { ProductDetailsView } from './ProductDetailsView';
import './ProductDetailsLayout.css';

export function ProductDetailsLayout({ product, admin = false, canViewRevoltDesktopDownloads = false, manager, onOpenTagsModal, onOpenAccessTagsModal, onOpenImageModal, onOpenDownloadsModal, onFeaturedChange, onActiveChange, onBundleChange, onDeleteClick, onProductClick, onAddBundle, onRemoveBundle, onAddRelated, onRemoveRelated, onBuyClick, buyLoading = false }) {
  if (!product) return null;

  return (
    <div className="product-details-layout">
      {/* Product Gallery Section - Prominent image display */}
      <div className="product-gallery-section">
        <ProductImageGallery product={product} admin={admin} onClick={onOpenImageModal} />
      </div>

      {/* Product Details Section - Information and purchasing */}
      <div className="product-details-section">
        <ProductDetailsView
          product={product}
          admin={admin}
          canViewRevoltDesktopDownloads={canViewRevoltDesktopDownloads}
          manager={manager}
          onOpenTagsModal={onOpenTagsModal}
          onOpenAccessTagsModal={onOpenAccessTagsModal}
          onOpenImageModal={onOpenImageModal}
          onOpenDownloadsModal={onOpenDownloadsModal}
          onFeaturedChange={onFeaturedChange}
          onActiveChange={onActiveChange}
          onBundleChange={onBundleChange}
          onDeleteClick={onDeleteClick}
          onProductClick={onProductClick}
          onAddBundle={onAddBundle}
          onRemoveBundle={onRemoveBundle}
          onAddRelated={onAddRelated}
          onRemoveRelated={onRemoveRelated}
          onBuyClick={onBuyClick}
          buyLoading={buyLoading}
        />
      </div>
    </div>
  );
}